import { motion } from "framer-motion";
import { Leaf, Heart, Brain, Globe, Users, BookOpen } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { openWhatsApp, WHATSAPP_MESSAGES } from "@/lib/whatsapp";

const principles = [
  {
    key: "environment" as const,
    icon: Leaf,
  },
  {
    key: "respect" as const,
    icon: Heart,
  },
  {
    key: "learning" as const,
    icon: Brain,
  },
  {
    key: "international" as const,
    icon: Globe,
  },
  {
    key: "attention" as const,
    icon: Users,
  },
  {
    key: "development" as const,
    icon: BookOpen,
  },
];

export const Principles = () => {
  const { language, translations } = useLanguage();
  const t = translations;

  if (!t) return null;

  return (
    <section id="principles" className="py-20 px-4 bg-background">
      <div className="container mx-auto">
        <h2 className="section-title text-center">{t.principles.title}</h2>
        <p className="section-subtitle text-center">
          {t.principles.subtitle}
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
          {principles.map((principle, index) => (
            <motion.div
              key={principle.key}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="feature-card"
            >
              <div className="flex items-center mb-4">
                <principle.icon
                  className="w-8 h-8 text-primary mr-3"
                  strokeWidth={1.5}
                />
                <h3 className="text-xl font-medium">
                  {t.principles.items[principle.key].title}
                </h3>
              </div>
              <p className="text-muted-foreground">
                {t.principles.items[principle.key].description}
              </p>
            </motion.div>
          ))}
        </div>
        <div className="text-center mt-12">
          <button 
            onClick={() => openWhatsApp(WHATSAPP_MESSAGES.bookVisit[language])}
            className="btn-primary"
          >
            {t.principles.bookVisit}
          </button>
        </div>
      </div>
    </section>
  );
};
